import { toRef } from 'vue'
import { useField } from 'vee-validate'

export const defaultProps = {
  name: { type: String, required: true },
  label: { type: String, default: '' },
  description: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  successMessage: { type: String, default: '' },
  placeholder: { type: String, default: '' },
}

export default function (props) {
  // use `toRef` to create reactive references to `name` prop which is passed to `useField`
  // this is important because vee-validate needs to know if the field name changes
  // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
  const name = toRef(props, 'name')

  // we don't provide any rules here because we are using form-level validation
  // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField(name)

  return {
    name,
    inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  }
}
